import React from 'react';
interface SectionHeadingProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  align?: 'center' | 'left';
  tone?: 'navy' | 'white';
}
export function SectionHeading({
  children,
  size = 'md',
  align = 'center',
  tone = 'navy'
}: SectionHeadingProps) {
  return <h2 className={`font-heading font-extrabold uppercase leading-[1.1] ${size === 'lg' ? 'text-xl sm:text-3xl' : 'text-lg sm:text-2xl'} ${align === 'center' ? 'text-center' : 'text-left'} ${tone === 'white' ? 'text-white' : 'text-navy'}`} data-id="element-207" data-mp="3k06w9t0d6pxq">
      {children}
    </h2>;
}